import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Layout from '../../components/Layout';
import Title from '../../components/Title';
import Button from '../../components/Button';
import Spinner from '../../components/Spinner';

import useCases from '../../useCases';

import { Images } from '../../themes';
import {
  Container,
  Content,
  Subtitle,
  HelperImage,
  Paragraph,
  H3,
  ButtonContainer,
} from './styles';

export default function Install({ lead }) {
  const [fetching, setFetching] = useState(false);

  const handleInstall = async () => {
    setFetching(true);
    await useCases.installInStation(lead.email);
    setFetching(false);
  };

  return (
    <Layout activeRoute="activate" mapImageOnBackground={false}>
      <Container>
        <Content>
          <Title>
            All set with the permissions. Time to{' '}
            <highlight>install the InStation</highlight> on Microsoft Teams
          </Title>
          <Subtitle>
            You will install the InStation on Microsoft Teams and get start
            directly in the app
          </Subtitle>
          <Paragraph>
            That´s all, now you´re going to install the app on your teams, and
            create your workspace with clusters and rooms, follow all the
            instructions on the app to build your enviroment and see how you can
            install the InStation to all members in your company. We ´re also
            adding our bot, that is necessary for some notifications about users
            and rooms it will be added without any effort from you. Enjoy!
          </Paragraph>
          <H3>See you on the InStation!</H3>
          <ButtonContainer>
            {fetching ? (
              <Spinner size={{ width: 408, height: 47 }} />
            ) : (
              <Button
                fullWidth
                onClick={handleInstall}
                icon={Images.icons.teams}
                alt="Microsoft Teams icon"
                text="Install InStation on Microsoft Teams"
              />
            )}
          </ButtonContainer>
        </Content>
        <HelperImage id="msTeams" src={Images.microsoftTeams} />
      </Container>
    </Layout>
  );
}

Install.propTypes = {
  lead: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    company: PropTypes.string,
    phone: PropTypes.string,
  }),
};
